import React from "react";
import getSymbolFromCurrency from 'currency-symbol-map';
import styles from './../Prices.module.scss';

interface MonthlyPrice {
  name: string;
  currency_code: string;
  price: number;
  duration_metric: string;
}

interface FullPriceProps {
  names: string[];
  prices: MonthlyPrice[];
}
const getCurrencySymbol = (currency_code: string): string => {
  if (currency_code === "COP") {
    return "COP";
  } else if (currency_code === "HKD") {
    return "HK$";
  } else {
    return getSymbolFromCurrency(currency_code) || currency_code;
  }
};
const FullPrice: React.FC<FullPriceProps> = ({ names, prices }) => {
  return (
    <div>
      {prices.length > 0 && (
        names.slice(0, 2).map((name, index) => (
          <div key={name} className={styles.container}>
            <span>
              {name}
            </span>
            <div>
              {
                prices.find((item) => item.name == names[index])?.price ? (
                  <>
                    <p>
                      {`\u00a0from ${
                          getCurrencySymbol(prices[index].currency_code) ||
                        prices[index].currency_code
                      }
                      ${prices.find((item) => item.name == names[index])?.price}`}
                    </p>
                    <span className={styles.duration}>
                      {`/${
                        prices.find((item) => item.name == names[index])?.duration_metric || "month"
                      }`}
                    </span>
                  </>
                ) : (
                  <div>
                  {
                    prices.find((item) => item.name == names[index])?.price ? (
                      <>
                        <p>
                          {`\u00a0from ${
                              getCurrencySymbol(prices[index].currency_code) ||
                            prices[index].currency_code
                          }
                          ${prices.find((item) => item.name == names[index])?.price}`}
                        </p>
                        <span className={styles.duration}>
                          {`/${
                            prices.find((item) => item.name == names[index])?.duration_metric || "month"
                          }`}
                        </span>
                      </>
                    ) : (
                      <div style={{ display: 'flex' }}>
                        {'\u00a0'}<p className={styles.price_on_request}>Price on request</p>
                      </div>
                    )
                  }
                </div>
                )
              }
            </div>
          </div>
        ))
      )}
    </div>
  )
}

export default FullPrice;